import { AnyType, FiltersController, IPredicate, TControllerValue } from '@centra/centra-ui/dist'
import { IOptionBase } from '@centra/centra-ui/dist/atoms/Select/models'
import { TFilterValues, TOptions } from '@centra/centra-ui/dist/molecules/Filters/models'
import queryString from 'query-string'

export const getQueryObjFromValue = (value: Map<string, TControllerValue<TFilterValues>>) => {
  const queryObj: { [x: string]: AnyType } = {}

  for (const [key, val] of value) {
    if (val?.value && Array.isArray(val.value)) {
      queryObj[key] = val?.value?.map(el => (el as AnyType).value)
    }
  }
  return queryObj
}

export const getQueryObjFromPredicates = (predicates?: IPredicate[]) => {
  if (!predicates) return {}
  const queryObj = predicates.reduce((acc: { [key: string]: number[] | string[] }, obj) => {
    if (obj.operator === 'LESS_THAN_EQUALS') {
      acc['createdTo'] = obj.values
    }
    if (obj.operator === 'GREATER_THAN_EQUALS') {
      acc['createdFrom'] = obj.values
    }
    if (obj.operator === 'IN' || obj.operator === 'EQUALS') {
      acc[obj.field] = obj.values
    }
    return acc
  }, {})

  return queryObj
}

const getOptionLabel = (filterName: string, item: AnyType) => {
  if (filterName === 'productIds') {
    return item.status === 'published'
      ? `${item.name} (опубликован) #${item.id}`
      : `${item.name} (не опубликован) #${item.id}`
  }
  if (filterName === 'accountManagerIds') {
    return `${item.firstName} ${item.lastName}`
  }
  return item.name
}

interface IGetOptionsProps {
  options: TOptions
  query: string
  filterName: string
  setSelectValue?: (value: React.SetStateAction<IOptionBase[]>) => void
}

export const getSelectOptionsAndSetValue = ({ options, query, filterName, setSelectValue }: IGetOptionsProps) => {
  const params = queryString.parse(query, { arrayFormat: 'bracket', parseNumbers: true })

  const mapedOptions: AnyType[] = options
    .map(item => ({
      id: item.id,
      value: filterName === 'accountManagerIds' ? getOptionLabel(filterName, item) : item.id,
      label: getOptionLabel(filterName, item),
      dotColor: item.colorAlias,
      img: item.newLogo?.imageSizeUrls?.['thumb'],
      email: item.email,
      avatar: item.avatar,
      firstName: item.firstName,
      lastName: item.lastName,
    }))
    .sort((a, b) => {
      if (filterName === 'productIds' || filterName === 'clientIds' || filterName === 'accountManagerIds') {
        return a.label.localeCompare(b.label)
      }
    })
  if (params[filterName]) {
    const filteredArray = mapedOptions.filter(obj => (params[filterName] as number[])?.includes(obj.id))

    setSelectValue?.(filteredArray)
  }

  return mapedOptions
}

interface IUpdatePredicateProps {
  predicate: IPredicate[]
  v: AnyType
  filterName: string
  controller: FiltersController
}

export const updatePredicates = ({ predicate, v, filterName, controller }: IUpdatePredicateProps) => {
  const filterIndex = predicate.findIndex(filter => filter.field === filterName)
  const values = v.map((item: AnyType) => item.id)

  let updatedFilters
  if (filterIndex === -1) {
    updatedFilters = [...predicate, { field: filterName, operator: 'IN', values }]
  } else {
    updatedFilters = predicate.map(filter => (filter.field === filterName ? { ...filter, values } : filter))
  }

  controller.updateDefaultValues(updatedFilters as IPredicate[])
}

export const updatePredicateInput = ({ predicate, v, filterName, controller }: IUpdatePredicateProps) => {
  const filterIndex = predicate.findIndex(filter => filter.field === filterName)

  let updatedFilters
  if (filterIndex === -1) {
    updatedFilters = [...predicate, { field: filterName, operator: 'EQUALS', values: [v] }]
  } else {
    updatedFilters = predicate.map(filter => (filter.field === filterName ? { ...filter, values: [v] } : filter))
  }

  controller.updateDefaultValues(updatedFilters as IPredicate[])
}
